/**
 * 백엔드 페이징 응답 형태가 달라도 공통으로 꺼내 쓰기 위한 헬퍼
 * 지원 예:
 * - { list: [], total: 123, pageNum: 1, pageSize: 10 }
 * - { items: [], totalCount: 123, page: 1, size: 10 }
 * - PageHelper(PageInfo): { list: [], total: 123, pageNum: 1, pageSize: 10 }
 */
export function normalizePage(data) {
  const d = data || {};
  const rows = d.list || d.items || d.data || [];
  const total = Number(d.total ?? d.totalCount ?? d.count ?? 0);
  const pageNum = Number(d.pageNum ?? d.page ?? 1);
  const pageSize = Number(d.pageSize ?? d.size ?? 10);
  return { rows, total, pageNum, pageSize };
}
